import '@Global/user';
import '@Global/modal';
import '@Global/home-page';
import '@Global/notifications';

import App from '@Components/app';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import {LoadingToast} from '@Components/loading-toast';
import type {ReactElement} from 'react';
import {renderApp} from '@Utils/renderApp.util';

export function PremiumPricingApp(): ReactElement {
  return (
    <App>
      <ModalContainerDeprecated />
      <ModalContainer />
      <LoadingToast />
    </App>
  );
}

renderApp(<PremiumPricingApp />, 'premium-pricing-app');
